import PropTypes from 'prop-types'
import styled from 'styled-components'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--vo-white);
  border-left: 4px solid ${({ $color }) => $color || 'var(--color-brand)'};
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 20px 22px;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  ${({ $clickable }) =>
    $clickable &&
    `
    &:hover {
      box-shadow: var(--shadow-md);
      transform: translateY(-1px);
    }
  `}
`

const Label = styled.span`
  font-family: var(--font-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vo-slate);
`

const Value = styled.span`
  font-family: var(--font-primary);
  font-size: 28px;
  font-weight: 800;
  color: ${({ $color }) => $color || 'var(--color-brand)'};
  line-height: 1;
`

const Sub = styled.span`
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--vo-slate);
`

export const StatCard = ({ label, value, sub, color, onClick }) => (
  <Card $color={color} $clickable={!!onClick} onClick={onClick}>
    <Label>{label}</Label>
    <Value $color={color}>{value}</Value>
    {sub && <Sub>{sub}</Sub>}
  </Card>
)

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sub: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}
